export const ENVIRONMENTS = [
    'dev',
    'uat',
    'prod'];


// WEBPACK FOOTER //
// ./src/app/services/constants/environment-list.ts